import { initialState } from "./state"

export default {
  setListOptionsOffers: (state, payload) => (state.listOptionsOffers = payload),
  setRulesOffers: (state, payload) => (state.rulesOffers = payload),

  setOffersSelecteds: (state, payload) => (state.offersSelecteds = payload),
  setOffersMobileSelecteds: (state, payload) =>
    (state.offersMobileSelecteds = payload),
  setOffersTvSelecteds: (state, payload) => (state.offersTvSelecteds = payload),
  putOffersSelecteds: (state, payload) => {
    const alreadyInCart = state.offersSelecteds.some(offer => offer.uuid === payload.uuid)

    if (!alreadyInCart) {
      state.offersSelecteds.push(payload)
    }
  },
  deleteOffersSelecteds: (state, indexToRemove) =>
    state.offersSelecteds.splice(indexToRemove, 1),

  resetOffer: state => {
    const init_state = initialState()
    Object.assign(state, init_state)
  },
  setParamsFilter: (state, payload) => (state.paramsFilter = payload),
  setAvaliableNumberOptions: (state, payload) =>
    (state.avaliableNumberOptions = payload),
  setAvaliableNumberOptionsByKey: (state, { key, options }) => {
    state.avaliableNumberOptions = {
      ...state.avaliableNumberOptions,
      [key]: options
    }
  },
  setFilterCampaignSelecteds: (state, payload) =>
    (state.filterCampaignSelecteds = payload),
  setFilterCampaignSelectedsToInitial: state =>
    (state.filterCampaignSelecteds = initialState().filterCampaignSelecteds),
  setOfferBillingDiscount: (state, payload) => {
    state.offerBillingDiscount = payload
  },
}
